// src/features/system/iam/hooks/useComms.ts
//
// React Query mutation hooks for admin comms actions (send emails to users).

import { useMutation, useQuery } from '@tanstack/react-query';
import {
  sendAdminWelcome,
  sendAdminReset,
  sendAdminNotify,
  fetchCommsHealth,
  type CommsSendResponse,
  type NotifyPayload,
  type CommsHealthResponse,
} from '../api/commsApi';

/* ─── Send welcome email to user ──────────────────────────── */

export function useSendWelcome() {
  return useMutation<CommsSendResponse, Error, number>({
    mutationFn: (idUser) => sendAdminWelcome(idUser),
  });
}

/* ─── Send password-reset email to user ───────────────────── */

export function useSendReset() {
  return useMutation<CommsSendResponse, Error, number>({
    mutationFn: (idUser) => sendAdminReset(idUser),
  });
}

/* ─── Send custom notification to user ────────────────────── */

export function useSendNotify() {
  return useMutation<CommsSendResponse, Error, { idUser: number } & NotifyPayload>({
    mutationFn: ({ idUser, ...payload }) => sendAdminNotify(idUser, payload),
  });
}

/* ─── Comms health check ──────────────────────────────────── */

export function useCommsHealth(enabled = true) {
  return useQuery<CommsHealthResponse, Error>({
    queryKey: ['comms-health'],
    queryFn: () => fetchCommsHealth(),
    staleTime: 30_000,
    enabled,
  });
}
